import store from "@/store";

export default [
    {
        path: '/events',
        name: 'events',
        component: () => import(/* webpackChunkName: "events" */ '../views/CalendarPage.vue'),
        beforeEnter: (to, from, next) => {
            if (store.state.appConfig.showCalendar) {
                next({name: 'homepage'})
                return
            }
            next()
        }
    },
    {
        path: '/e/:eventSlug([0-9a-f]{8})',
        name: 'homepage-event',
        // redirect: {name: 'checkins-list'}
        component: () => import(/* webpackChunkName: "homepage" */ '../views/HomePage.vue'),
        beforeEnter: (to, from, next) => {
            if (store.getters['auth/isAuthenticated']) {
                next('/checkins')
                return
            }
            next()
        },
    },
]

